module.exports = __webpack_public_path__ + "ece658de966af1a4f076b656166def30.svg";